<template>
  <div class="hot-activity" v-show="activityList && activityList.length">
    <div class="activity-head">
      <div class="title">热门活动</div>
      <div v-if="activityNum>4" class="item-head-right">
        <div :class="['right-back',{active:!leftBtnShow}]" style="margin-right:40px" @click="onLeft">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div :class="['right-back',{active:!rightBtnShow}]" @click="onRight">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="hot-activity-wrap-box">
      <div class="hot-activity-wrap">
        <activity-com class="hot-activity" v-for="(item, index) in activityList" :key="index" :activityInfo="item"></activity-com>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ActivityCom from './activityCard.vue'
export default {
  name: 'hot-activity',
  components: {
    ActivityCom
  },
  props: {
    projectCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activityList: [],
      activityDict: {
        1: 'lottery',
        2: 'common',
        3: 'getLikes',
        4: 'vote',
        5: 'bargain',
        6: 'group',
        7: 'activitySquare',
      },
      activityNum: 0,
      activityIndex: 0,
    }
  },
  computed: {
    ...mapGetters(['homePage']),
    leftBtnShow () {
      if (this.activityIndex <= 0) {
        return false
      } else {
        return true
      }
    },
    rightBtnShow () {
      if (this.activityIndex <= this.activityNum-5) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.getActivities()
  },
  methods: {
    // 获取热门活动
    getActivities(){
      const params = {
        page: 1,
        limit: 10,
        homePageId: this.homePage.id,
        locationId: 2,
        projectCode: this.projectCode
      }
      this.$api.getActivities(params).then(res => {
        let activityList = res.data.list || []
        activityList = activityList.map(item => {
          item.exhibitionActivityType = this.activityDict[item.exhibitionActivityType]
          switch (item.exhibitionActivityType) {
            case 'common':
              item.page = `exhibitionHall/activity/detail?code=${item.activityCode}&projectCode=${item.projectCode}`
              break
            case 'lottery':
              item.name = item.activityName
              item.coverPicture = item.coverPic
              item.page = `/pages/common/lottery/bootsLottery/index?activityId=${item.activityId}&projectCode=${item.projectCode}`
              break
            case 'getLikes':
              item = {
                ...item.baseInfo,
                coverPicture: item.resource.coverPic,
                startTime: item.baseInfo.startAt,
                endTime: item.baseInfo.endAt,
                name: item.baseInfo.activityName,
                exhibitionActivityType: 'getLikes',
              }
              item.page = `/pages/common/getLikes/index?id=${item.code}`
              break
            case 'bargain':
              item.coverPicture = item.adviserCoverPic
              item.page = `/pages/common/bargain/index?bargainActivityId=${item.id}&projectCode=${item.projectCode}`
              break
            case 'group':
              item = {
                ...item,
                name: item.activityName,
                page: `/pages/common/groupActivity/index?code=${item.code}&projectCode=${item.projectCode}`,
                startTime: item.startAt,
                endTime: item.endAt,
              }
              break
            case 'vote':
              item.coverPicture = item.entranceImg
              item.page = `/pages/votingActivities/activitie?id=${item.id}&projectCode=${item.projectCode}`
              break
            case 'activitySquare':
              item.name = item.activityName
              item.page = `/pages/common/activity/index?landingPageId=${item.activityId}&projectCode=${item.projectCode}`
              break
            default:
              item.name = item.activityName || item.name
              break
          }
          return item
        })
        this.activityList = activityList
        this.activityNum = this.activityList.length
      })
    },
    onLeft(){
      if(!this.leftBtnShow){
        return
      }
      this.activityIndex = this.activityIndex - 1
      let activityBox = document.querySelector(".hot-activity-wrap")
      activityBox.style.marginLeft = -290*this.activityIndex+"px";
    },
    onRight(){
      if(!this.rightBtnShow){
        return
      }
      this.activityIndex = this.activityIndex + 1
      let activityBox = document.querySelector(".hot-activity-wrap")
      activityBox.style.marginLeft = -290*this.activityIndex+"px";
    }
  }
}
</script>
<style lang="scss" scoped>
.hot-activity{
  margin-bottom: 60px;
  .activity-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      @include font24(bold, #333333);
      margin-bottom: 16px;
    }
    .item-head-right{
      .item-more{
        cursor: pointer;
        @include font16(400, #9399A5)
      }
      display: flex;
      .right-back{
        width: 40px;
        height: 40px;
        border: 1px solid #BDA26C;
        border-radius: 50%;
        cursor: pointer;
        text-align: center;
        line-height: 40px;
        i{
          font-size: 24px;
          line-height: 40px;
          color: #BDA26C;
        }
        &.active{
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }
  .hot-activity-wrap-box{
    margin: 24px 0;
    font-size: 0;
    width: 100%;
    height: 220px;
    overflow: hidden;
    // white-space: nowrap;
    // overflow-x: auto;
    // overflow-y: hidden;
    // scrollbar-width: none; /* firefox */
    // -ms-overflow-style: none; /* IE 10+ */
    .hot-activity-wrap{
      margin-left: 0;
      display: flex;
      white-space: nowrap;
    }
    .hot-activity{
      display: inline-block;
      margin-right: 10px;
    }
    .hot-activity:last-child{
      margin-right: 0;
    }
  }
  .hot-activity-wrap::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
</style>
